import { Coord } from '../../jscaip/Coord';
import { Player, PlayerOrNone } from '../../jscaip/Player';
import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class SquarzState extends PlayerOrNoneGameStateWithTable {
    static of(oldState, newBoard) {
        return new SquarzState(newBoard, oldState.turn);
    }
    getDominantPlayer() {
        const scores = this.getScores();
        const scoreZero = scores.get(Player.ZERO);
        const scoreOne = scores.get(Player.ONE);
        if (scoreZero === scoreOne) {
            return PlayerOrNone.NONE;
        }
        else if (scoreZero < scoreOne) {
            return PlayerOrNone.ONE;
        }
        else {
            return PlayerOrNone.ZERO;
        }
    }
    setPieceAt(coord, value) {
        return GameStateWithTable.setPieceAt(this, coord, value, SquarzState.of);
    }
    getScores() {
        const scores = PlayerNumberMap.of(0, 0);
        for (const coordAndContent of this.getCoordsAndContents()) {
            const piece = coordAndContent.content;
            if (piece.isPlayer()) {
                scores.add(piece, 1);
            }
        }
        return scores;
    }
    hasMovablePieceAt(coord, jumpSize) {
        for (let y = -jumpSize; y <= jumpSize; y++) {
            for (let x = -jumpSize; x <= jumpSize; x++) {
                const landingCoord = new Coord(coord.x + x, coord.y + y);
                if (this.isEmptyAt(landingCoord)) {
                    return true;
                }
            }
        }
        return false;
    }
}
